import { fetchDynamicsData, fetchCompareDynamics, fetchDynamicsCoinsList } from "@/Groups/Scanner/private/api/dynamicsData";

const state = () => ({
  dynamics: [],
  isReady: false,
  isOpened: true,
  isLoading: false,
  idActiveDynamic: null,
  compareDynamic: [],
});

const actions = {
  async updateDynamicsList({ state, commit }, { custom_tag_id, base_coin_id, tag_id, usd }){
    try{
      let params = {};
      if(base_coin_id) params['base_coin_id'] = base_coin_id;
      if(custom_tag_id) params['custom_tag_id'];
      if(usd) params['usd'] = true;
      if(tag_id) params['tag_id'] = tag_id;
      commit('SET_LOADING_FLAG', true);
      const data = await fetchDynamicsData(params);
      commit('SET_READY_FLAG', true);
      commit('SET_DATA', data);
      return data;
    } catch(err){
      console.warn('Ошибка', err)
    } finally{
      commit('SET_LOADING_FLAG', false);
    }
  },

  async loadCoinsList({ state, commit }, params){
    try{
      commit('SET_ACTIVE_DYNAMIC_ID', params.period);
      return await fetchDynamicsCoinsList(params);
    } catch(err){
      console.warn('Ошибка', err)
    } finally{
      commit('SET_LOADING_FLAG', false);
    }
  },

  async loadCompare({ state, commit }, params) {
    try {
      commit('SET_LOADING_FLAG', true);
      const data = await fetchCompareDynamics(params);
      commit('SET_COMPARE_DYNAMIC', data);
      return data;
    } catch (err) {
      console.warn('Ошибка при загрузке сравнения импульсов:', err);
    } finally {
      commit('SET_LOADING_FLAG', false);
    }
  },

  async resetCompare({ commit }) {
    commit('SET_COMPARE_DYNAMIC', null);
  },

  setActiveDynamicsId({ commit }, id) {
    commit('SET_ACTIVE_DYNAMIC_ID', id);
  },

  toggleOpended({ state, commit }){
    const status = (state.isOpened) ? false : true;
    commit('SET_OPENED_LIST_FLAG', status);
  },

  // Сброс всего состояния модуля
  resetDynamics({ commit }) {
    commit('SET_DATA', []);
    commit('SET_COMPARE_DYNAMIC', []);
    commit('SET_READY_FLAG', false);
    commit('SET_LOADING_FLAG', false);
    commit('SET_OPENED_LIST_FLAG', true);
    commit('SET_ACTIVE_DYNAMIC_ID', null);
  },
};

const mutations = {
  SET_DATA(state, data){ state.dynamics = data; },

  SET_COMPARE_DYNAMIC(state, data) { state.compareDynamic = data; },

  SET_READY_FLAG(state, status = true){ state.isReady = status; },

  SET_LOADING_FLAG(state, status){ state.isLoading = status; },

  SET_OPENED_LIST_FLAG(state, status){ state.isOpened = status; },

  SET_ACTIVE_DYNAMIC_ID(state, id){ state.idActiveDynamic = id; }
};

const getters = {
  //Возвращает весь список периодов
  allDynamics: (state) => state.dynamics,
  //Флаг, указывающий, были ли периоды успешно загружены
  isDynamicReady: (state) => state.isReady,
  //Флаг, указывающий, выполняется ли загрузка периодов в данный момент
  isDynamicLoading: (state) => state.isLoading,
  //Возвращает период по его ID, если найден, иначе null
  getDynamicById: (state) => (id) => state.dynamics.find(p => p.id === id) || null,
  //Возвращает количество загруженных периодов
  dynamicsCount: (state) => state.dynamics.length,
  //Развернут ли список периодов
  isOpenedList: (state) => state.isOpened,
  //Получить активный ID периода
  activeDynamicId: (state) => state.idActiveDynamic,
  //Получить список compare impulse
  getCompareDynamic: (state) => state.compareDynamic,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

const compare = [
    {
        "period": "1d",
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "price_start": "113488.71960110240000",
            "price_end": "109293.47356903930000",
            "change_percent": -3.7
        },
        "compare_coin": {
            "id": 49881,
            "name": "Pudgy Penguins",
            "symbol": "PENGU",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/pudgy-penguins_36x36.webp",
            "price_start": "0.02998864000000",
            "price_end": "0.02700359000000",
            "change_percent": -9.95
        },
        "change_percent": -9.95,
        "relative_percent": -6.25
    },
    {
        "period": "1w",
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "price_start": "117093.61357568168000",
            "price_end": "109293.47356903930000",
            "change_percent": -6.66
        },
        "compare_coin": {
            "id": 49881,
            "name": "Pudgy Penguins",
            "symbol": "PENGU",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/pudgy-penguins_36x36.webp",
            "price_start": "0.03821275000000",
            "price_end": "0.02700359000000",
            "change_percent": -29.33
        },
        "change_percent": -29.33,
        "relative_percent": -22.67
    }
]